import { defHttp } from '/@/utils/http/axios';

enum Api {
    filterData = '/sys/sysFilter/listNoPage',
    getAreaListApi = '/prj/planExecutor/selectAreaList',
}

export const getFilterData = () => {
    return defHttp.get({ url: Api.filterData }, {errorMessageMode:'none'});
};

export const customQuery = async ({url, method, params = {}, ignoreCancelToken = true}) => {
    return defHttp[method]({ url, params, headers: {
        ignoreCancelToken, // select组件多次搜索支持取消之前请求
    }});
}

export const getAreaList = () =>
  defHttp.get({url: Api.getAreaListApi}, {errorMessageMode:'none'});